<style lang="scss" scoped>
.list {
  height: 100%;
  .item {
    border: 1px solid #dcdfe6;
    position: relative;
    text-align: left;
    cursor: pointer;
    padding-bottom: 10px;
    &.active {
      &::after {
        font-family: 'iconfont' !important;
        background: rgba($color: #000000, $alpha: 0.8);
        color: #fff;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        content: '\e607';
        font-size: 20px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    .title {
      padding: 0 10px;
      box-sizing: border-box;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
    }
    .desc {
      padding: 8px;
      line-height: 19px;
    }
    .img {
      width: 100%;
      height: 160px;
    }
    &.multi {
      .first {
        position: relative;
        .title {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          color: #fff;
          background: rgba(0, 0, 0, 0.7);
        }
      }
      .other {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        padding: 15px 0;
        &:last-child {
          border: none;
        }
        .title {
          font-size: 14px;
          line-height: 20px;
          height: 60px;
        }
        .img {
          flex-shrink: 0;
          margin-right: 10px;
          margin-left: 10px;
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}
.articleLib {
  /deep/ {
    .el-dialog__body {
      padding: 10px 0 30px 0;
    }
  }
}
</style>

<template>
  <div style="display: inline-block;">
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="选择图文"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="articleLib"
      :append-to-body="true"
    >
      <div class="list">
        <Waterfall class="clearfix" :gutterHeight="30" :gutterWidth="30" :minCol="3">
          <WaterfallItem
            class="item multi"
            :width="300"
            v-for="item in list"
            :key="item.materialId"
            :class="{active:item.materialId == active.materialId}"
            @click.native="select(item)"
          >
            <template v-if="item.content.news.length>1">
              <div v-for="(item2,index) in item.content.news" :key="index">
                <template v-if="!index">
                  <div class="first">
                    <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                    <div class="title line1">{{item2.title}}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="other">
                    <div class="title line3">{{item2.title}}</div>
                    <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="title line1">{{item.content.news[0].title}}</div>
              <el-image :src="item.content.news[0].thumbUrl" lazy fit="cover" class="img"></el-image>
              <div class="desc">{{item.content.news[0].digest}}</div>
            </template>
          </WaterfallItem>
        </Waterfall>
      </div>
      <div class="alignc">
        <el-pagination
          :current-page.sync="page"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="totalSize"
          @current-change="getItem"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Waterfall, WaterfallItem } from 'vue2-waterfall';

export default {
  components: {
    Waterfall,
    WaterfallItem,
  },
  props: ['reply'],
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      dialog: false,
      page: 1,
      size: 8,
      list: [],
      totalSize: 0,
      active: {},
    };
  },
  methods: {
    confirm() {
      let data = Object.assign({}, this.active);
      this.$emit('confirm', data);
      this.dialog = false;
    },
    show() {
      this.active = {};
      this.dialog = true;
      this.getItem();
    },
    async getItem() {
      let res = await this.$http(`/api/${this.id}/materials`, {
        params: {
          type: 3,
          page: this.page,
          size: this.size,
        },
      });
      this.totalSize = res.totalSize;
      this.list = res.list;
    },
    select(item) {
      console.log(item, this.reply);
      if (!this.reply && item.content.news.length > 1) {
        this.$message.error('当前模块不支持多图文');
        return;
      }
      this.active = item;
    },
  },
  mounted() {
    console.log(this.reply);
  },
};
</script>
